import React, { Component } from 'react';
import '../../css/pages/customers.css';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Nav from 'react-bootstrap/esm/Nav';
import SideNav from '../components/SideNav';
import TopNav from '../components/TopNav';
import { fetchAgent, fetchAgentStats } from '../actions/account';
import Pagination from '../components/Pagination';
import { fetchLoans } from '../actions/p2p';

class ViewCustomer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loans: [],
      current_page: new URLSearchParams(props.location.search).get('page') || 1,
      limit: 10,
    };
  }

  handlePageChange = (data) => {
    const { limit } = this.state;
    const { match } = this.props;
    fetchLoans(data.currentPage, '', 'created_on', 'DESC', limit, '', match.params.id)
      .then(({ data: { loans, page_info } }) => this.setState({
        loans,
        current_page: page_info.page,
        total: page_info.total,
      }));
  };

  render() {
    const {
      loans, total, current_page, limit, reports = [], details = [],
    } = this.state;
    const { history } = this.props;
    return (
      <>
        <SideNav page="loans" />
        <main className="body-main">
          <div className="body-main__container">
            <TopNav page="loans" />
            <section className="body-main__content">
              <div className="loans">
                <div className="pageTitle d-lg-none">
                  <h3 className="pageTitle__header">Customer</h3>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="">
                      <div className="filter-and-search d-flex justify-content-end">
                        
                      </div>
                      {!!details.length && (
                        <div className="card default-card page-table mb-4">
                          <div className="row">
                            {details.map((detail) => (
                              <div className="col-12 col-md-3" key={detail.title}>
                                <div>
                                  <p>{detail.title}</p>
                                  <h6 className="fw-bold">
                                    {detail.description}
                                  </h6>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      {!!reports.length && (
                        <div className="card default-card page-table mb-4">
                          <div className="row">
                            {reports.map((report) => (
                              <div className="col-12 col-md-3" key={report.id}>
                                <div>
                                  <p>{report.title}</p>
                                  <h6 className="fw-bold">
                                    {report.description}
                                  </h6>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      <div className="row">
                        <div className="col">
                          <div className="card default-card settings">
                            <Nav
                              className="nav nav-tabs"
                              as="ul">
                              <Nav.Item as="li" className="nav-item">
                                <Nav.Link className="nav-link active" eventKey="profile">
                                  Loans
                                </Nav.Link>
                              </Nav.Item>
                            </Nav>
                            <div className="tab-content">
                              <div className="tab-pane fade show active">
                                <div className="table-responsive">
                                  <table className="table">
                                    <thead className="bg-secondary">
                                      <tr>
                                        <th className="loan_amount text-white px-5">Loan Amount</th>
                                        <th className="interest text-white">Interest</th>
                                        <th className="status text-white">Status</th>
                                        <th className="date-time text-white">Date</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {loans.map((loan) => (
                                        <tr key={loan.id} onClick={() => history.push(`/loans/${loan.id}`)} role="button">
                                          <td className="loan_amount px-5">{Number(loan.loan_amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                                          <td className="interest">
                                            {loan.interest_rate}
                                            %
                                          </td>
                                          <td className="status">{loan.status?.status}</td>
                                          <td className="date-time">
                                            <span className="date">{moment(loan.created_on).format('MMM DD, YYYY, h:mm:ss a')}</span>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <Pagination
                        totalRecords={total}
                        pageLimit={limit}
                        pageNeighbours={1}
                        onPageChanged={this.handlePageChange}
                        initialPage={current_page} />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>
      </>
    );
  }
}

export default ViewCustomer;
